export const reschedule = {
  'Confirm schedule': 'Confirmar agenda',
  'Select the date and time of the schedule':
    'Seleccioná la fecha y hora de la agenda',
  'Session successfully rescheduled to {{unit}}, {{date}} at {{time}}!':
    '¡Sesión reprogramada con éxito para {{unit}}, el {{date}} a las {{time}}!',
  "You're almost at your schedule, but before choose where do you want to receive your confirmation code from":
    'Ya casi estás en tu agenda, pero antes elegí por dónde querés recibir tu código de confirmación',
};
